import { render, staticRenderFns } from "./ProjectRole.vue?vue&type=template&id=bad8315c&scoped=true&"
import script from "./ProjectRole.vue?vue&type=script&lang=js&"
export * from "./ProjectRole.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRole.vue?vue&type=style&index=0&id=bad8315c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad8315c",
  null
  
)

export default component.exports